import script from "./VistaOrganizacionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VistaOrganizacionComponent.vue?vue&type=script&setup=true&lang=js"

import "./VistaOrganizacionComponent.vue?vue&type=style&index=0&id=87b6d946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87b6d946"]])

export default __exports__